import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@utils/seo";
import i18n from "@modules/shared/localization/i18n";
import { CartPageView } from "@modules/shop/components/Cart/CartPageView";

export const Route = createFileRoute("/$locale/_layout/(public)/_public/cart")({
  component: CartPage,
  ssr: true,
  headers: () => ({
    "Cache-Control": "private, no-store",
  }),
  head: ({ params }) => {
    const t = i18n.getFixedT(params.locale);
    return {
      meta: [
        ...seo({
          title: t("Seo:cart.title"),
          description: t("Seo:cart.description"),
          robots: "noindex, nofollow",
        }),
      ],
    };
  },
});

function CartPage() {
  const { locale } = Route.useParams();
  return <CartPageView locale={locale} />;
}
